// extracted by mini-css-extract-plugin
export default {"recos":"e5-z","productCardOverride":"f5-z","rowHasBadge":"g5-z"};